import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import FreeGuidePage from "./pages/FreeGuidePage";
import EbookPage from "./pages/EbookPage";
import AdminReviewsPage from "./pages/AdminReviewsPage";
import AuthCallback from "./pages/AuthCallback";
import { Toaster } from "./components/ui/sonner";
import "./styles/LandingPage.css";
import "./styles/InteractiveEnhancements.css";
import "./styles/HandwritingVisuals.css";
import "./styles/ExpandableServices.css";
import "./styles/Certifications.css";
import "./styles/GlitterEffect.css";
import "./styles/ServicesVideo.css";
import "./styles/UnifiedTitles.css";
import "./styles/ConsistencyOverrides.css";
import "./styles/FinalTouches.css";

/**
 * AppRouter — synchronous session_id detection before any route runs.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
function AppRouter() {
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/services" element={<Navigate to="/#services" replace />} />
      <Route path="/cultural-needs-assessment" element={<ServiceDetailPage slug="cultural-needs-assessment" />} />
      <Route path="/cultural-competency-consulting" element={<ServiceDetailPage slug="cultural-competency-consulting" />} />
      <Route path="/case-management" element={<ServiceDetailPage slug="case-management" />} />
      <Route path="/organizational-case-management" element={<Navigate to="/case-management" replace />} />
      <Route path="/concierge-case-management" element={<ServiceDetailPage slug="concierge-case-management" />} />
      <Route path="/culturally-responsive-coaching" element={<ServiceDetailPage slug="culturally-responsive-coaching" />} />
      <Route path="/diaspora-wellness-coaching" element={<Navigate to="/culturally-responsive-coaching" replace />} />
      <Route path="/services/:slug" element={<ServiceDetailPage />} />
      <Route path="/free-starter-guide" element={<FreeGuidePage />} />
      <Route path="/free-guide" element={<Navigate to="/free-starter-guide" replace />} />
      <Route path="/culturally-responsive-practice-guide" element={<EbookPage />} />
      <Route path="/ebook" element={<Navigate to="/culturally-responsive-practice-guide" replace />} />
      <Route path="/admin/reviews" element={<AdminReviewsPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
